import Bugsnag from '@bugsnag/js'

export function notify<T extends Error>(err: T) {
    if (process.env.REACT_APP_BUGSNAG_KEY) {
        Bugsnag.notify(err)
    } else {
        console.error(err)
    }
}
